import { gql } from '@apollo/client';
import { Program } from '@src/graphql/home/queries/getProgramsByUuid';

export interface LearningLifecyclesVariables {
  memberUuid: string;
}

export interface LearningLifecyclesData {
  academicPartnerUuid?: string;
  actualCompletionDate?: string | null;
  applicationId?: string;
  applicationType?: string;
  completionUuid?: string | null;
  expectedCompletionDate?: string | null;
  milestones?: string[];
  programUuid?: string;
  program?: Program;
}

export interface LearningLifecyclesResponse {
  learningLifecycles: LearningLifecyclesData[];
}

export const GET_LEARNING_LIFECYCLES_DATA = gql`
  query GET_LEARNING_LIFECYCLES_DATA($memberUuid: ID!) {
    learningLifecycles(memberUuid: $memberUuid) {
      academicPartnerUuid
      actualCompletionDate
      applicationId
      applicationType
      completionUuid
      expectedCompletionDate
      milestones
      programUuid
    }
  }
`;
